if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');
				this.variantIdInput.disabled = false;
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');
				this.submitButtonText = this.submitButton.querySelector('span');

				if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading__spinner').classList.remove('hidden');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				// Get selected accessories
				const accessories = getSelectedAccessories();

				// Add main product first
				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButtonText.classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						// Add accessories if any are selected
						if (accessories.length > 0) {
							this.addAccessoriesToCart(accessories, response).then((finalResponse) => {
								this.handleCartUpdate(finalResponse || response, formData.get('id'));
							}).catch((error) => {
								console.error('Error adding accessories:', error);
								// Still update cart with main product even if accessories fail
								this.handleCartUpdate(response, formData.get('id'));
							});
						} else {
							this.handleCartUpdate(response, formData.get('id'));
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton.removeAttribute('aria-disabled');
						this.querySelector('.loading__spinner').classList.add('hidden');

						CartPerformance.measureFromEvent("add:user-action", evt);
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			toggleSubmitButton(disable = true, text) {
				if (disable) {
					this.submitButton.setAttribute('disabled', 'disabled');
					if (text) this.submitButtonText.textContent = text;
				} else {
					this.submitButton.removeAttribute('disabled');
					this.submitButtonText.textContent = window.variantStrings.addToCart;
				}
			}

			get variantIdInput() {
				return this.form.querySelector('[name=id]');
			}

			addAccessoriesToCart(accessories, mainProductResponse) {
				const cart = this.cart;
				const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
				const sectionsUrl = window.location.pathname;
				
				// Add accessories sequentially to ensure order
				let promiseChain = Promise.resolve(mainProductResponse);
				
				accessories.forEach((accessory) => {
					promiseChain = promiseChain.then((previousResponse) => {
						const accessoryFormData = new FormData();
						accessoryFormData.append('id', accessory.id);
						accessoryFormData.append('quantity', accessory.quantity);
						if (sections.length > 0) {
							accessoryFormData.append('sections', sections);
							accessoryFormData.append('sections_url', sectionsUrl);
						}
						
						const config = fetchConfig('javascript');
						config.headers['X-Requested-With'] = 'XMLHttpRequest';
						delete config.headers['Content-Type'];
						config.body = accessoryFormData;
						
						return fetch(`${routes.cart_add_url}`, config)
							.then((response) => response.json())
							.then((response) => {
								if (response.status) {
									console.warn('Failed to add accessory:', accessory.id, response.description);
									// Continue with previous response even if accessory fails
									return previousResponse;
								}
								return response;
							})
							.catch((error) => {
								console.error('Error adding accessory:', error);
								// Continue with previous response even if accessory fails
								return previousResponse;
							});
					});
				});
				
				return promiseChain;
			}

			handleCartUpdate(response, productVariantId) {
				const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
				if (!this.error) {
					publish(PUB_SUB_EVENTS.cartUpdate, {
						source: 'product-form',
						productVariantId: productVariantId,
						cartData: response,
					}).then(() => {
						CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
					});
				}
				this.error = false;
				const quickAddModal = this.closest('quick-add-modal');
				if (quickAddModal) {
					document.body.addEventListener(
						'modalClosed',
						() => {
							setTimeout(() => {
								CartPerformance.measure("add:paint-updated-sections", () => {
									this.cart.renderContents(response);
								});
							});
						},
						{ once: true }
					);
					quickAddModal.hide(true);
				} else {
					CartPerformance.measure("add:paint-updated-sections", () => {
						this.cart.renderContents(response);
					});
				}
			}
		}
	);
}
